import { render, staticRenderFns } from "./NdaSignedCell.vue?vue&type=template&id=632e5980&"
import script from "./NdaSignedCell.vue?vue&type=script&lang=ts&"
export * from "./NdaSignedCell.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports